<template>
  <v-container fluid>
          <v-dialog v-model="showDialog" max-width="500px">
       <v-card>
          <v-card-title>
            <span class="headline">Brix/Temp Measurement</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md10>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      :item="editItem.date"
                      label="Date:"
                      :value="prettyDate(editItem.date)"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="date" no-title scrollable>
                      <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click.native="saveDate(date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field type="number" v-model.number="editItem.brix" label="Brix"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field type="number" v-model.number="editItem.temp" label="Temp"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="closeDialog">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="updateDialog">Save</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-toolbar dense>
      <v-icon @click="goBack">chevron_left</v-icon>
      <!-- <v-btn color="primary" @click="generatePDFs">PDF</v-btn> -->
      <v-spacer></v-spacer>
      <v-toolbar-title>Brix & Temps<br>{{lot}} {{vesselType}}-{{vesselID}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon @click="refresh">refresh</v-icon>
    </v-toolbar>
     <br>
      <v-layout align-center justify-center row fill-height>
        <v-flex xs5>
          <v-data-table pa-0 ma-0
            :headers='headers'
            :items='brixTemps'
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td><v-icon small @click="editItemTapped(props.item, props.index)">edit</v-icon></td>
                <td>{{props.item.date}}</td>
                <td>{{props.item.brix}}</td>
                <td>{{props.item.temp}}</td>
                <td><v-icon @click="deleteItem(props.item, props.index)" small>delete</v-icon></td>
              </tr>
            </template>
          </v-data-table>
          <v-btn small @click="addItem()">ADD MEASUREMENT</v-btn>
        </v-flex>
        <v-flex xs1></v-flex>
        <v-flex xs6>
          <v-divider></v-divider>
          <GChart v-if='brixTemps.length > 0'
            type="LineChart"
            :data="brix"
            :options="chartOptions"
          ></GChart>
        </v-flex>
      </v-layout>
      <div v-if='otherBrixTemps.length > 0 && isStaff()'>
      <br>
      <v-divider></v-divider>
      <br>
        <v-layout align-center justify-center row fill-height>
          <v-flex xs5>
            <v-data-table pa-0 ma-0
              :headers='headers'
              :items='otherBrixTemps'
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td><v-icon small @click="editItemTapped(props.item, props.index)">edit</v-icon></td>
                  <td>{{props.item.date}}</td>
                  <td>{{props.item.brix}}</td>
                  <td>{{props.item.temp}}</td>
                  <td><v-icon @click="deleteItem(props.item, props.index)" small>delete</v-icon></td>
                </tr>
              </template>
            </v-data-table>
            <v-btn small @click="transfer()">TRANSFER TO {{vesselType}}-{{vesselID}}</v-btn>
          </v-flex>
          <v-flex xs7></v-flex>
        </v-layout>
      </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import async from 'async'
import myMixins from '../mixins/myMixins'
import moment from 'moment'
import { GChart } from 'vue-google-charts'

export default {
  data () {
    return {
      date: '',
      menu: false,
      showDialog: false,
      editItem: {},
      editItemIndex: 0,
      headers: [
        { text: 'EDIT', value: 'action', sortable: false, width: '10px' },
        { text: 'DATE', value: 'date', sortable: false, width: '25px' },
        { text: 'BRIX', value: 'brix', sortable: false, width: '25px' },
        { text: 'TEMP', value: 'temp', sortable: false, width: '25px' },
        { text: 'DELETE', value: 'delete', sortable: false, width: '10px' }
      ],
      brixTemps: [],
      otherBrixTemps: [],
      brix: [['Date', 'Brix', 'Temp']],
      temps: [],
      chartOptions: {
        height: 400,
        vAxes: { 0: { logScale: false, mixValue: -2, maxValue: 30 },
          1: { logScale: false, minValue: 50, maxValue: 100 } },
        chartArea: {
          'width': '80%',
          'height': '90%'
        },
        title: 'Brix/Temp Curves',
        titleTextStyle: {
          color: 'white'
        },
        series: {
          0: { targetAxisIndex: 0 },
          1: { targetAxisIndex: 1 }
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        display: false,
        legend: {
          textStyle: {
            color: 'white'
          }
        }
      }
    }
  },
  mixins: [myMixins],
  created () {
    this.retrieveAllBrixTemps()
  },
  components:
    {
      GChart
    },
  computed: {
    lot () {
      return this.$route.params.lot
    },
    vesselType () {
      return this.$route.params.vesselType
    },
    vesselID () {
      return this.$route.params.vesselID
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      return this.$store.state.client.CODE
    }
  },
  watch: {
  },
  methods: {
    refresh () {
      this.retrieveAllBrixTemps()
    },
    saveDate (value) {
      this.editItem.date = value
      this.menu = false
    },
    addItem () {
      delete this.editItem.id
      this.editItem.lot = this.lot
      this.editItem.vesselType = this.vesselType
      this.editItem.vessel = this.vesselID
      this.editItem.brix = 0
      this.editItem.temp = 0
      this.editItem.date = moment().format('YYYY-MM-DD')
      this.date = this.editItem.date
      this.showDialog = true
    },
    deleteItem (value, index) {
      axios
        .delete(process.env.VUE_APP_BACKEND+'brixtemps/' + value.id)
        .then(response => {
          this.refresh()
        })
    },
    editItemTapped (value, index) {
      this.editItem = value
      this.date = this.editItem.date
      this.editItemIndex = index
      this.showDialog = true
    },
    closeDialog () {
      this.showDialog = false
    },
    updateDialog () {
      this.showDialog = false
      if (!this.editItem.id) {
        axios
          .post(process.env.VUE_APP_BACKEND+'brixtemps', this.editItem)
          .then(response => {
            response.data.data.date = moment(response.data.data.date).format('YYYY-MM-DD')
            this.refresh()
          })
      } else {
        axios
          .put(process.env.VUE_APP_BACKEND+'brixtemps/' + this.editItem.id, this.editItem)
          .then(response => {
            this.refresh()
          })
      }
    },
    transfer () {
      axios
        .put(process.env.VUE_APP_BACKEND+'brixtemps?lot='+ this.$route.params.lot +
           '&vesselType=' + this.$route.params.vesselType +
           '&vesselID=' + this.$route.params.vesselID)
        .then(response => {
          this.retrieveAllBrixTemps()
        })
    },
    retrieveAllBrixTemps () {
      axios
        .get(process.env.VUE_APP_BACKEND+'brixtemps?lot='+ this.$route.params.lot +
           '&vesselType=' + this.$route.params.vesselType +
           '&vesselID=' + this.$route.params.vesselID)
        .then(response => {
          this.brixTemps = response.data.data
          this.brix = [['Date', 'Brix', 'Temp']]
          this.brixTemps.forEach(item => {
            this.brix.push([item.date, item.brix, item.temp])
          })
        })
      axios
        .get(process.env.VUE_APP_BACKEND+'brixtemps?showOther=true&lot='+ this.$route.params.lot +
           '&vesselType=' + this.$route.params.vesselType +
           '&vesselID=' + this.$route.params.vesselID)
        .then(response => {
          this.otherBrixTemps = response.data.data
          // this.brix = [['Date', 'Brix', 'Temp']]
          // this.brixTemps.forEach(item => {
          //   this.brix.push([item.date, item.brix, item.temp])
          // })
        })
    }
  }
}
</script>
<style>
.v-input {font-size: 12px;}
.v-list__tile__title {font-size: 12px;}
table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child, table.v-table thead td:not(:first-child),
 table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 5px;
}
td {
  vertical-align: center;
}
table.v-table tbody td, table.v-table tbody th {
    height: 30px;
}
</style>
